import clsx from 'clsx'
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const PlatformService = ({ ArrowIcon, dropdownOpen, setDropdownOpen, subDropdownOpen, setSubDropdownOpen, refTabOurSolution }) => {
  return (
    <div className="relative">
      <Link
        to="#"
        className="text-[#101838] text-sm xl:text-base leading-[150%]"
        onClick={() => dropdownOpen !== 'platform-service' ? setDropdownOpen('platform-service') : setDropdownOpen('')}
      >
        Products and Services
        <ArrowIcon/>
      </Link>

      <div className={clsx(
        'bg-neutral-10 absolute rounded border-l-2 border-l-primary-main mt-9 z-[1]',
        dropdownOpen === 'platform-service' ? 'flex' : 'hidden'
      )}>
        <div className="w-[280px] border-r border-r-neutral-30">
          <Link
            className=" border-b border-b-neutral-30 hover:rounded hover:bg-[#F7F8FA] text-s-reguler text-neutral-100 py-2 px-4 flex justify-between"
            to="/retail"
            onClick={() => {
              setDropdownOpen('')
            }}
            // onClick={() => subDropdownOpen !== 'procure' ? setSubDropdownOpen('procure') : setSubDropdownOpen('')}
          >
            Manuva Retail: Solution for our Retail Customers
            {/* <ArrowIcon className="transform -rotate-90"/> */}
          </Link>

          <Link
            className="border-b border-b-neutral-30 hover:rounded hover:bg-[#F7F8FA] text-s-reguler text-neutral-100 py-2 px-4 flex justify-between"
            to="/"
            onClick={() => {
              setTimeout(() => {
                document.getElementById('our-solution').scrollIntoView()
                refTabOurSolution.current.setSelectedIndexTab(1)
              }, 500)
              setDropdownOpen('')
            }}
            // onClick={() => subDropdownOpen !== 'retail' ? setSubDropdownOpen('retail') : setSubDropdownOpen('')}
          >
            Manuva Procure: Solution for our B2B Customers
            {/* <ArrowIcon className="transform -rotate-90"/> */}
          </Link>

          <Link
            className="hover:rounded hover:bg-[#F7F8FA] text-s-reguler text-neutral-100 py-2 px-4 flex justify-between"
            to="/"
            onClick={() => {
              setTimeout(() => {
                document.getElementById('our-solution').scrollIntoView()
                refTabOurSolution.current.setSelectedIndexTab(2)
              }, 500)
              setDropdownOpen('')
            }}
            // onClick={() => subDropdownOpen !== 'supply' ? setSubDropdownOpen('supply') : setSubDropdownOpen('')}
          >
            Manuva Supply: Solution for out Manufacturers and Suppliers
            {/* <ArrowIcon className="transform -rotate-90"/> */}
          </Link>
        </div>

        <div className={clsx(
          'w-[280px]',
          subDropdownOpen === '' ? 'hidden' : 'block'
        )}>
          <div className={clsx(
            subDropdownOpen === 'procure' ? 'block' : 'hidden'
          )}>
            <h1 className="text-neutral-100 text-s-reguler py-2 px-4">Manuva Procure</h1>
            <Link to="#" className="text-primary-main text-s-reguler py-2 px-4">
                    Made-to-order products and projects
            </Link>
          </div>

          <div className={clsx(
            subDropdownOpen === 'retail' ? 'block' : 'hidden'
          )}>
            <Link to="/retail" className="text-primary-main text-s-reguler py-2 px-4">
              Manuva Retail
            </Link>
            <Link to="#" className="text-primary-main text-s-reguler py-2 px-4">
              Stock up goods for retail stores
            </Link>
          </div>

          <div className={clsx(
            subDropdownOpen === 'supply' ? 'block' : 'hidden'
          )}>
            <h1 className="text-neutral-100 text-s-reguler py-2 px-4">Manuva Supply</h1>
            <Link to="#" className="text-primary-main text-s-reguler py-2 px-4">
                      Raw Material Marketplace
            </Link>
            <Link to="#" className="text-primary-main text-s-reguler py-2 px-4">
                      Early Payment
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

PlatformService.propTypes = {
  ArrowIcon: PropTypes.node,
  dropdownOpen: PropTypes.string,
  setDropdownOpen: PropTypes.func,
  subDropdownOpen: PropTypes.string,
  setSubDropdownOpen: PropTypes.func,
  refTabOurSolution: PropTypes.node
}

export default PlatformService
